import React from "react";
import { useInstance } from "../../context/instance.context";

export default function FileFormatSupport() {
    const { organizationPdfLogo: organizationLogo } = useInstance();
    // console.log("Data useInstance :", data);
    return (
        <div className="bg-white min-h-screen">
            {/* Navbar */}
            <nav className="flex bg-[#f5f0f5] items-center justify-between px-[300px] py-4 h-32 bg-gray-  shadow-md">
                <div className="flex items-center">
                    {organizationLogo && <img src={organizationLogo} alt="Logo" className="h-10" />}
                </div>
            </nav>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-4 py-8 text-gray-800">
                <h1 className="text-3xl font-bold mb-4">
                    Why Our Application Supports Only STEP and STP File Formats
                </h1>
                {/* <div className="flex items-center mb-4">
                    <div className="w-10 h-10 bg-blue-500 text-white rounded-full flex items-center justify-center font-bold text-lg">
                        A
                    </div>
                    <div className="ml-3 text-sm text-gray-600">
                        Written by Allison Hall<br />
                        Updated over 4 months ago
                    </div>
                </div> */}
                <p className="mb-6">
                    When it comes to 3D modeling and CAD file formats, there are various options,
                    including <strong>STEP (.step, .stp), STL, 3MF, and other native CAD formats</strong>. However, not all file types
                    are created equal—especially when precision, compatibility, and downstream usability are key factors.
                </p>

                <h2 className="text-2xl font-semibold mb-2">The Limitations of STL and Mesh-Based Files</h2>
                <p className="mb-4">
                    While <strong>STL</strong> (stereolithography) is commonly used in 3D printing, it has serious drawbacks when used
                    in professional CAD workflows:
                </p>
                <ul className="list-disc list-inside mb-6 space-y-2">
                    <li>
                        <span className="text-red-500 mr-2">🚫</span>
                        <strong>Loss of Design Information</strong> – STL converts 3D models into simple triangular meshes,
                        stripping away important design parameters.
                    </li>
                    <li>
                        <span className="text-red-500 mr-2">🚫</span>
                        <strong>Accuracy Issues</strong> – Triangulated surfaces introduce approximations that can lead to errors
                        in machining, assembly, and simulation.
                    </li>
                    <li>
                        <span className="text-red-500 mr-2">🚫</span>
                        <strong>Difficult to Edit</strong> – Modifying an STL file is complex since it lacks structured CAD features,
                        making it unsuitable for further engineering work.
                    </li>
                </ul>

                <h2 className="text-2xl font-semibold mb-2">The Superiority of STEP and STP Files</h2>
                <p className="mb-4">
                    <strong>STEP (Standard for the Exchange of Product Data)</strong> files are widely adopted across industries
                    for several reasons:
                </p>
                <ul className="list-disc list-inside mb-6 space-y-2">
                    <li>
                        <span className="text-green-500 mr-2">✅</span>
                        <strong>Universally Recognized</strong> – STEP is an ISO standard (ISO 10303) designed for seamless data exchange across CAD platforms.
                    </li>
                    <li>
                        <span className="text-green-500 mr-2">✅</span>
                        <strong>High Precision</strong> – Unlike STL, which only contains triangulated mesh data, STEP files store complete geometric and parametric details.
                    </li>
                    <li>
                        <span className="text-green-500 mr-2">✅</span>
                        <strong>Preserves Design Intent</strong> – It retains exact dimensions, curves, and CAD features, making it ideal for further design modifications and simulations.
                    </li>
                    <li>
                        <span className="text-green-500 mr-2">✅</span>
                        <strong>Perfect for Manufacturing & Analysis</strong> – The solid geometry representation in STEP allows for better manufacturability and engineering analysis.
                    </li>
                </ul>

                <h2 className="text-2xl font-semibold mb-2">Why We Support Only STEP and STP</h2>
                <p className="mb-4">
                    To ensure the best experience for our users, our application exclusively supports <strong>STEP and STP files</strong>. This guarantees:
                </p>
                <ul className="list-disc list-inside mb-6 space-y-2">
                    <li><span className="text-purple-500 mr-2">✔️</span><strong>Accurate Design Representation</strong></li>
                    <li><span className="text-purple-500 mr-2">✔️</span><strong>Better Interoperability Across CAD Software</strong></li>
                    <li><span className="text-purple-500 mr-2">✔️</span><strong>Seamless Modifications & Analysis</strong></li>
                    <li><span className="text-purple-500 mr-2">✔️</span><strong>Error-Free Manufacturing</strong></li>
                </ul>
                <p className="mb-6">
                    If you’re looking for <strong>high-quality, manufacturable, and editable</strong> 3D files, <strong>STEP/STP</strong> is the way to go!
                </p>
                <p className="text-sm">Got questions? Contact us, and we’ll be happy to help. 🚀</p>
            </div>
        </div>
    );
}
